// (function () {
//   if (typeof jQuery === "undefined" || !window.jQuery.fn?.slick) {
//     const jQueryScript = document.createElement("script");
//     jQueryScript.src = "https://cdn.jsdelivr.net/npm/jquery@3.6.0/dist/jquery.min.js";
//     document.head.appendChild(jQueryScript);

//     const slickScript = document.createElement("script");
//     slickScript.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
//     document.head.appendChild(slickScript);

//     const slickStyle = document.createElement("link");
//     slickStyle.rel = "stylesheet";
//     slickStyle.href = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css";
//     document.head.appendChild(slickStyle);
//   }

//   const modalHTML = `
//     <div class="bundle-quick-view-modal" style="display:none;">
//       <div class="bundle-quick-view-loader"></div>
//       <div class="bundle-quick-view-content">
//         <span class="bundle-quick-view-close">&times;</span>
//         <div class="bundle-quick-view-inner">
//           <div class="bundle-quick-view-media">
//             <div class="bundle-quick-view-slider"></div>
//           </div>
//           <div class="bundle-quick-view-details">
//             <div class="bundle-quick-view-title"></div>
//             <div class="bundle-quick-view-price"></div>
//             <div class="bundle-quick-view-info"></div>
//             <div class="bundle-quick-view-btn-wrap">
//               <button class="bundle-quick-view-full-btn">View Details</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>`;

//   if (!document.querySelector(".bundle-quick-view-modal")) {
//     document.body.insertAdjacentHTML("beforeend", modalHTML);
//   }

//   let currentSlug = null;

//   async function fetchProductHTML(slug) {
//     try {
//       const res = await fetch(`/products/${slug}`);
//       if (!res.ok) {
//         window.location.href = `/products/${slug}`;
//         return null;
//       }
//       return await res.text();
//     } catch (error) {
//       console.error("Quick View Error:", error);
//       return null;
//     }
//   }

//   document.addEventListener("click", async (e) => {
//     const trigger = e.target.closest(".bundle-quick-view-btn");
//     if (!trigger) return;

//     const modal = document.querySelector(".bundle-quick-view-modal");
//     const loader = modal.querySelector(".bundle-quick-view-loader");
//     const content = modal.querySelector(".bundle-quick-view-content");
//     const sliderContainer = modal.querySelector(".bundle-quick-view-slider");
//     const titleEl = modal.querySelector(".bundle-quick-view-title");
//     const priceEl = modal.querySelector(".bundle-quick-view-price");
//     const infoEl = modal.querySelector(".bundle-quick-view-info");

//     // Reset modal
//     modal.style.display = "block";
//     loader.style.display = "block";
//     content.style.display = "none";
//     sliderContainer.innerHTML = "";
//     titleEl.innerHTML = "";
//     priceEl.innerHTML = "";
//     infoEl.innerHTML = "";

//     const productItem = trigger.closest(".product, .product-card, .st-product-wrap");
//     const anchor = productItem?.querySelector('a[href*="/products/"]');
//     const slugMatch = anchor?.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
//     const slug = slugMatch?.[1];
//     if (!slug) return;
//     currentSlug = slug;

//     const productHTML = await fetchProductHTML(slug);
//     if (!productHTML) return;

//     const parser = new DOMParser();
//     const productDoc = parser.parseFromString(productHTML, "text/html");

//     const imageEls = productDoc.querySelectorAll('.productView-img-container img[src]');
//     const filteredImgs = Array.from(imageEls).filter(img => {
//       const src = img.getAttribute("src");
//       return src && !src.includes("icon") && !src.includes("View_similar") && !src.includes("play-button");
//     });

//     if (filteredImgs.length === 0) {
//       sliderContainer.innerHTML = `<div><p>No images found</p></div>`;
//       loader.style.display = "none";
//       content.style.display = "block";
//     } else {
//       let loaded = 0;
//       filteredImgs.forEach((img) => {
//         const src = img.getAttribute("data-src") || img.getAttribute("src");
//         const image = new Image();
//         image.src = src;
//         image.alt = "";
//         image.style.width = "100%";
//         image.style.height = "auto";

//         image.onload = () => {
//           loaded++;
//           if (loaded === filteredImgs.length) {
//             jQuery(sliderContainer).slick({
//               dots: true,
//               arrows: false,
//               infinite: true
//             });
//             loader.style.display = "none";
//             content.style.display = "block";
//           }
//         };

//         const slide = document.createElement("div");
//         slide.appendChild(image);
//         sliderContainer.appendChild(slide);
//       });
//     }

//     const productTitle = productDoc.querySelector(".productView-title")?.textContent;
//     if (productTitle) titleEl.textContent = productTitle;

//     const productPrice = productDoc.querySelector(".price-item--regular")?.outerHTML;
//     if (productPrice) priceEl.innerHTML = productPrice;

//     const desc = productDoc.querySelector(".tab-content#tab-description .toggle-content")
//       || productDoc.querySelector(".custom-accordion-wrapper .accordion-item:first-child .accordion-content");
//     if (desc) infoEl.innerHTML = desc.innerHTML;
//   });

//   document.addEventListener("click", (e) => {
//     const modal = document.querySelector(".bundle-quick-view-modal");
//     if (e.target.classList.contains("bundle-quick-view-close")) {
//       modal.style.display = "none";

//       const slider = modal.querySelector(".bundle-quick-view-slider");
//       if (window.jQuery && jQuery(slider).hasClass("slick-initialized")) {
//         jQuery(slider).slick("unslick");
//       }
//     }

//     if (e.target.classList.contains("bundle-quick-view-full-btn")) {
//       if (currentSlug) {
//         window.location.href = `/products/${currentSlug}`;
//       }
//     }
//   });
// })();



(function () {
  if (typeof jQuery === "undefined" || !window.jQuery.fn?.slick) {
    const jQueryScript = document.createElement("script");
    jQueryScript.src = "https://cdn.jsdelivr.net/npm/jquery@3.6.0/dist/jquery.min.js";
    jQueryScript.async = false;
    document.head.appendChild(jQueryScript);

    const slickScript = document.createElement("script");
    slickScript.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
    slickScript.async = false;
    document.head.appendChild(slickScript);

    const slickStyle = document.createElement("link");
    slickStyle.rel = "stylesheet";
    slickStyle.href = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css";
    document.head.appendChild(slickStyle);

    const slickThemeStyle = document.createElement("link");
    slickThemeStyle.rel = "stylesheet";
    slickThemeStyle.href = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css";
    document.head.appendChild(slickThemeStyle);
  }

  const modalHTML = `
    <div class="bundle-quick-view-modal" style="display:none;">
      <div class="bundle-quick-view-loader"></div>
      <div class="bundle-quick-view-content">
        <span class="bundle-quick-view-close">×</span>
        <div class="bundle-quick-view-inner">
          <div class="bundle-quick-view-media">
            <div class="bundle-quick-view-slider"><div class="skeleton"></div></div>
          </div>
          <div class="bundle-quick-view-details">
            <div class="bundle-quick-view-title"></div>
            <div class="bundle-quick-view-price"></div>
            <div class="bundle-quick-view-info"></div>
            <div class="bundle-quick-view-btn-wrap">
              <button class="bundle-quick-view-full-btn">View Details</button>
            </div>
          </div>
        </div>
      </div>
    </div>`;

  if (!document.querySelector(".bundle-quick-view-modal")) {
    document.body.insertAdjacentHTML("beforeend", modalHTML);
  }

  let currentSlug = null;

  async function fetchProductHTML(slug) {
    try {
      const res = await fetch(`/products/${slug}`);
      if (!res.ok) {
        window.location.href = `/products/${slug}`;
        return null;
      }
      return await res.text();
    } catch (error) {
      console.error("Quick View Error:", error);
      return null;
    }
  }

  async function waitForSlick() {
    return new Promise((resolve) => {
      if (window.jQuery && jQuery.fn.slick) {
        resolve();
      } else {
        const interval = setInterval(() => {
          if (window.jQuery && jQuery.fn.slick) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
      }
    });
  }

  document.addEventListener("click", async (e) => {
    const trigger = e.target.closest(".bundle-quick-view-btn");
    if (!trigger) return;

    const modal = document.querySelector(".bundle-quick-view-modal");
    const loader = modal.querySelector(".bundle-quick-view-loader");
    const content = modal.querySelector(".bundle-quick-view-content");
    const sliderContainer = modal.querySelector(".bundle-quick-view-slider");
    const titleEl = modal.querySelector(".bundle-quick-view-title");
    const priceEl = modal.querySelector(".bundle-quick-view-price");
    const infoEl = modal.querySelector(".bundle-quick-view-info");

    modal.style.display = "none"; 
    setTimeout(() => { modal.style.display = "block"; }, 10);
    loader.style.display = "block";
    content.style.display = "none";
    sliderContainer.innerHTML = `<div class="skeleton"></div>`; 
    titleEl.innerHTML = "";
    priceEl.innerHTML = "";
    infoEl.innerHTML = "";

    const productItem = trigger.closest(".product, .product-card, .st-product-wrap");
    const anchor = productItem?.querySelector('a[href*="/products/"]');
    const slugMatch = anchor?.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
    const slug = slugMatch?.[1];
    if (!slug) return;
    currentSlug = slug;

    const productHTML = await fetchProductHTML(slug);
    if (!productHTML) return;

    const parser = new DOMParser();
    const productDoc = parser.parseFromString(productHTML, "text/html");

    const imageEls = productDoc.querySelectorAll('.productView-img-container img[src]');
    const filteredImgs = Array.from(imageEls).filter(img => {
      const src = img.getAttribute("src");
      return src && !src.includes("icon") && !src.includes("View_similar") && !src.includes("play-button");
    });

    const productTitle = productDoc.querySelector(".productView-title")?.textContent;
    const productPrice = productDoc.querySelector(".price-item--regular")?.outerHTML;
    const desc = productDoc.querySelector(".tab-content#tab-description .toggle-content")
      || productDoc.querySelector(".custom-accordion-wrapper .accordion-item:first-child .accordion-content");

    if (filteredImgs.length === 0) {
      sliderContainer.innerHTML = `<div><p>No images found</p></div>`;
      loader.style.display = "none";
      content.style.display = "block";
      // Populate details now
      if (productTitle) titleEl.textContent = productTitle;
      if (productPrice) priceEl.innerHTML = productPrice;
      if (desc) infoEl.innerHTML = desc.innerHTML;
    } else {
      sliderContainer.innerHTML = ""; 
      await waitForSlick(); 

      filteredImgs.forEach((img, index) => {
        const src = img.getAttribute("data-src") || img.getAttribute("src");
        const image = new Image();
        image.src = src;
        image.alt = "";
        image.style.width = "100%";
        image.style.height = "auto";
        image.style.display = "block";
        image.loading = index > 0 ? "lazy" : "eager";

        const slide = document.createElement("div");
        slide.style.width = "100%";
        slide.style.display = "block";
        slide.appendChild(image);
        sliderContainer.appendChild(slide);

        image.onload = () => {
          if (index === 0 && !jQuery(sliderContainer).hasClass("slick-initialized")) {
            try {
              console.log("Initializing Slick for", sliderContainer);
              jQuery(sliderContainer).slick({
                dots: true,
                arrows: false,
                infinite: true,
                lazyLoad: 'ondemand',
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true
              });
              setTimeout(() => {
                jQuery(sliderContainer).slick('setPosition');
                console.log("Slick refreshed");
              }, 100);
              loader.style.display = "none";
              content.style.display = "block";
              if (productTitle) titleEl.textContent = productTitle;
              if (productPrice) priceEl.innerHTML = productPrice;
              if (desc) infoEl.innerHTML = desc.innerHTML;
            } catch (error) {
              console.error("Slick initialization failed:", error);
              sliderContainer.style.display = "block";
              sliderContainer.style.overflowX = "auto";
              sliderContainer.style.whiteSpace = "nowrap";
              loader.style.display = "none";
              content.style.display = "block";
              // Populate details in fallback
              if (productTitle) titleEl.textContent = productTitle;
              if (productPrice) priceEl.innerHTML = productPrice;
              if (desc) infoEl.innerHTML = desc.innerHTML;
            }
          }
        };

        image.onerror = () => {
          console.warn("Image failed to load:", src);
          slide.innerHTML = `<div><p>Image failed to load</p></div>`;
        };
      });
    }
  });

  document.addEventListener("click", (e) => {
    const modal = document.querySelector(".bundle-quick-view-modal");
    if (e.target.classList.contains("bundle-quick-view-close")) {
      modal.style.display = "none";

      const slider = modal.querySelector(".bundle-quick-view-slider");
      if (window.jQuery && jQuery(slider).hasClass("slick-initialized")) {
        try {
          jQuery(slider).slick("unslick");
        } catch (error) {
          console.error("Error unslicking slider:", error);
        }
      }
    }

    if (e.target.classList.contains("bundle-quick-view-full-btn")) {
      if (currentSlug) {
        window.location.href = `/products/${currentSlug}`;
      }
    }
  });
})();